"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveSL = void 0;
const types_1 = require("./types");
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../../../../interface");
const utils_1 = require("../utils");
/**
 * 运行中仓位的止损限制
 */
class ActiveSL extends types_1.TPSLLimiter {
    valueOf() {
        const { order: originOrder, mode, curPrice, takerFee, offsetLimit } = this.params;
        const order = originOrder;
        const isLong = order.side === interface_1.CustomOrderSide.BUY;
        const sideD = isLong ? 1 : -1;
        // 收益最大/最小化的价格限制
        const priceModeRes = {
            // 强平价格*（1+方向*X）
            min: new trade_utils_lib_1.SafeDecimal(order.maint_price).mul(new trade_utils_lib_1.SafeDecimal(1).add(new trade_utils_lib_1.SafeDecimal(sideD).mul(offsetLimit !== null && offsetLimit !== void 0 ? offsetLimit : 0))),
            max: new trade_utils_lib_1.SafeDecimal(curPrice),
        };
        switch (mode) {
            case interface_1.SimpleFutures.TPSLMode.simple_amount:
                return {
                    min: utils_1.SimpleFuturesTPSLUtils.tpslPriceToProfit(priceModeRes.min, { order, takerFee }),
                    max: utils_1.SimpleFuturesTPSLUtils.tpslPriceToProfit(priceModeRes.max, { order, takerFee }),
                };
            case interface_1.SimpleFutures.TPSLMode.simple_price:
                return isLong ? priceModeRes : { min: priceModeRes.max, max: priceModeRes.min };
            case interface_1.SimpleFutures.TPSLMode.simple_rate:
            default:
                return {
                    min: utils_1.SimpleFuturesTPSLUtils.tpslPriceToProfitRate(priceModeRes.min, { order, takerFee }),
                    max: utils_1.SimpleFuturesTPSLUtils.tpslPriceToProfitRate(priceModeRes.max, { order, takerFee }),
                };
        }
    }
}
exports.ActiveSL = ActiveSL;
